import DataTable from '../../../../../components/DataTable'
import { dishesTypesTextStyle, nameEntity, nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import Container from '../../../../../components/Container'

const DishesTypesList = (): JSX.Element => (
  <Container pageTitle="Listagem" breadcrumb={breadcrumbList} tools={toolsList}>
    <DataTable
      source={nameSource}
      entity={nameEntity}
      format={{ orderBy: 'name' }}
      notHasChildren
      headers={headers}
      actions={[
        {
          name: 'Visualizar',
          title: 'Visualizar',
          spanIcon: 'fa fa-search',
          linkTo: dish => `/commercial/dishesTypes/view/${dish.id}`,
          style: { margin: '0 5px' }
        },
        {
          name: 'Editar',
          title: 'Editar',
          spanIcon: 'fa fa-edit',
          linkTo: dish => `/commercial/dishesTypes/update/${dish.id}`
        }
      ]}
      customHeaders={[
        {
          name: 'Imprimir em',
          field: 'text_style',
          sortable: false,
          element: item => (
            <span>
              {
                dishesTypesTextStyle[
                  item.text_style as keyof typeof dishesTypesTextStyle
                ]
              }
            </span>
          )
        }
      ]}
    />
  </Container>
)

export default DishesTypesList
